export const sortingFilter = {
  Newest: 0,
  MostLiked: 1,
  MostCommented: 2,
};
